export default __webpack_public_path__ + "static/media/utp-info.1fa3919d.svg";